import useTranslate from '@/composables/useTranslate'
import { computed } from 'vue'

function useChannelDetails(channelRef) {
  const { translate } = useTranslate()

  const itemDetails = computed(() => {
    const { beams } = channelRef.value
    if (beams) {
      if (beams.length) {
        const prefix = beams.length > 1
          ? translate('pb2.defaultItemDetails.beams')
          : translate('pb2.defaultItemDetails.beam')
        const beamsList = beams.map((beam) => beam.beam_index).join(', ')
        return `${prefix} ${beamsList}`
      }
      return translate('pb2.defaultItemDetails.allBeams')
    }
    return translate('pb2.defaultItemDetails.defaultBeams')
  })

  return itemDetails
}

export default useChannelDetails
